import React, { useState, useEffect } from 'react';
import { Card, Button, ButtonGroup } from 'react-bootstrap';
import { SeccionModal, EditSeccionModal, CategoriaModal, EditCategoriaModal } from './componentes/Modals';
import CategoriaCard from './componentes/categoriaCard';
import { fetchSecciones, fetchCategorias } from './Utils/ApiCategoria';
import { PencilFill, PlusCircleFill, EyeFill, EyeSlashFill, TrashFill, ThreeDots } from 'react-bootstrap-icons';
import { handleDeleteClick, handleDeleteSeccionClick } from './Utils/AlertsCategorias';
import APIserver from '../../../api/axiosConfig';

function AdminCategorias() {
  const [secciones, setSecciones] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [expandedSecciones, setExpandedSecciones] = useState({});
  const [modalState, setModalState] = useState({
    showSeccionModal: false,
    showEditSeccionModal: false,
    showCategoriaModal: false,
    showEditModal: false,
    currentSeccion: { idSeccion: '', nomSeccion: '' },
    currentCategoria: { idCategoria: null, nomCategoria: '', idSeccion: '', imagenCategoria: null },
  });
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      const seccionesData = await fetchSecciones();
      const categoriasData = await fetchCategorias();
      setSecciones(seccionesData);
      setCategorias(categoriasData);
      const initialExpandedState = seccionesData.reduce((acc, seccion) => {
        acc[seccion.idSeccion] = false;
        return acc;
      }, {});
      setExpandedSecciones(initialExpandedState);
    };
    loadData();
  }, []);

  const handleOpenModal = (type, data = {}) => {
    setModalState((prev) => ({ ...prev, [type]: true, ...data }));
  };

  const handleCloseModal = (type) => setModalState((prev) => ({ ...prev, [type]: false }));

  const toggleExpandSeccion = (idSeccion) => {
    const categoriasEnSeccion = categorias
      .filter((categoria) => categoria.idSeccion === idSeccion)
      .map((categoria, index) => ({
        idCategoria: categoria.idCategoria,
        idSeccion: categoria.idSeccion,
        orden: index + 1,
      }));

    //console.log(`Información de la sección ${idSeccion}:`, categoriasEnSeccion);

    setExpandedSecciones((prevState) => ({
      ...prevState,
      [idSeccion]: !prevState[idSeccion],
    }));
  };

  const handleDragStart = (event, index) => {
    event.stopPropagation();
    setDragging(true);
    event.dataTransfer.setData('index', index);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleSeccionDrop = async (event, targetIndex) => {
    if (!dragging) return;

    const draggedIndex = parseInt(event.dataTransfer.getData('index'), 10);
    const updatedSecciones = [...secciones];
    const [removed] = updatedSecciones.splice(draggedIndex, 1);
    updatedSecciones.splice(targetIndex, 0, removed);

    setSecciones(updatedSecciones);

    const seccionesToUpdate = updatedSecciones.map((seccion, index) => ({
      idSeccion: seccion.idSeccion,
      orden: index,
    }));

    try {
      const response = await APIserver.put('/api/secciones/actualizar-orden', { seccionesToUpdate });
      // console.log('Orden de secciones actualizado:', response.data);
    } catch (error) {
      console.error('Error al actualizar el orden de secciones:', error.response ? error.response.data : error.message);
    }

    setDragging(false);
  };

  const handleDragStartCategoria = (event, categoriaIndex, seccionId) => {
    event.dataTransfer.setData('categoriaIndex', categoriaIndex);
    event.dataTransfer.setData('seccionId', seccionId);
  };

  const handleDropCategoria = async (event, targetIndex, targetSeccionId) => {
    event.preventDefault();

    const draggedIndex = parseInt(event.dataTransfer.getData('categoriaIndex'), 10);
    const sourceSeccionId = parseInt(event.dataTransfer.getData('seccionId'), 10);

    if (draggedIndex === targetIndex && sourceSeccionId === targetSeccionId) return;

    const categoriasDeSeccion = categorias
      .filter((categoria) => categoria.idSeccion === targetSeccionId)
      .sort((a, b) => a.orden - b.orden);

    const [movedCategoria] = categoriasDeSeccion.splice(draggedIndex, 1);
    categoriasDeSeccion.splice(targetIndex, 0, movedCategoria);

    categoriasDeSeccion.forEach((categoria, index) => {
      categoria.orden = index + 1;
    });

    setCategorias((prevCategorias) =>
      prevCategorias.map((categoria) => {
        if (categoria.idSeccion === targetSeccionId) {
          const updated = categoriasDeSeccion.find((c) => c.idCategoria === categoria.idCategoria);
          return updated || categoria;
        }
        return categoria;
      })
    );

    // console.log(`Datos enviados para actualizar el orden de categorías en la sección ${targetSeccionId}:`,
    //  categoriasDeSeccion.map((c) => ({ idCategoria: c.idCategoria, orden: c.orden }))
    //);

    try {
      const response = await APIserver.put('/api/categorias/actualizar-orden', {
        categorias: categoriasDeSeccion.map((c) => ({
          idCategoria: c.idCategoria,
          idSeccion: targetSeccionId, // Incluye idSeccion aquí
          orden: c.orden,
        })),
      });
      //  console.log('Orden de categorías actualizado:', response.data);
    } catch (error) {
      console.error('Error al actualizar el orden de categorías:', error.response ? error.response.data : error.message);
    }

  };

  return (
    <div className="px-4">
      <div className="mt-4">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between mb-4">
          <p className="mb-2 mb-md-0 text-muted">
            Agrupa las categorías en secciones para tener todos tus productos ordenados.
          </p>
          <div className="d-flex mt-2 mt-md-0">
            <Button
              variant="dark"
              onClick={() => handleOpenModal('showSeccionModal')}
              className="d-flex align-items-center me-2 shadow-sm"
            >
              <PlusCircleFill className="me-2" /> Crear Sección
            </Button>
            <Button
              variant="danger"
              onClick={() => handleOpenModal('showCategoriaModal')}
              className="d-flex align-items-center shadow-sm"
            >
              <PlusCircleFill className="me-2" /> Crear Categoría
            </Button>
          </div>
        </div>
      </div>

      {secciones.map((seccion, index) => (
        <Card
          className="mb-4 shadow-sm"
          key={seccion.idSeccion}
          onDragOver={handleDragOver}
          onDrop={(e) => handleSeccionDrop(e, index)}
        >
          <Card.Header className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div className="mb-2 mb-md-0">
              <h4 className="text-dark">{seccion.nomSeccion}</h4>
              <small className="text-muted">Categorías: {seccion.totalCategorias}</small>
            </div>
            <ButtonGroup className="d-flex">
              <Button
                variant="link"
                className="me-2 d-flex align-items-center text-muted"
                draggable
                onDragStart={(e) => handleDragStart(e, index)}
              >
                <ThreeDots size={18} />
              </Button>
              <Button
                variant="link"
                className="me-2 d-flex align-items-center text-warning"
                onClick={() => handleOpenModal('showEditSeccionModal', { currentSeccion: seccion })}
                disabled={seccion.nomSeccion.toLowerCase() === 'otros'}

              >
                <PencilFill size={18} />
              </Button>
              <Button
                variant="link"
                className="me-2 d-flex align-items-center text-danger"
                onClick={() => handleDeleteSeccionClick(seccion)}
                disabled={seccion.nomSeccion.toLowerCase() === 'otros'}

              >
                <TrashFill size={18} />
              </Button>
              <Button
                variant="link"
                className="d-flex align-items-center text-dark"
                onClick={() => toggleExpandSeccion(seccion.idSeccion)}
              >
                {expandedSecciones[seccion.idSeccion] ? <EyeFill size={18} /> : <EyeSlashFill size={18} />}
              </Button>
            </ButtonGroup>
          </Card.Header>

          {expandedSecciones[seccion.idSeccion] && (
            <Card.Body>
              <div className="row justify-content-center">
                {categorias
                  .filter((categoria) => categoria.idSeccion === seccion.idSeccion)
                  .sort((a, b) => a.orden - b.orden) // Ordenar por el campo "orden"
                  .map((categoria, index) => (
                    <CategoriaCard
                      key={categoria.idCategoria}
                      categoria={categoria}
                      index={index}
                      onDragStart={(e) => handleDragStartCategoria(e, index, seccion.idSeccion)}
                      onDrop={(e) => handleDropCategoria(e, index, seccion.idSeccion)}
                      onDragOver={(e) => e.preventDefault()}
                      handleEditClick={() => handleOpenModal('showEditModal', { currentCategoria: categoria })}
                      handleDeleteClick={() => handleDeleteClick(categoria)}
                    />
                  ))}
              </div>
            </Card.Body>
          )}
        </Card>
      ))}

      <SeccionModal
        show={modalState.showSeccionModal}
        handleClose={() => handleCloseModal('showSeccionModal')}
        refreshSecciones={() => fetchSecciones().then(setSecciones)}
      />
      <EditSeccionModal
        show={modalState.showEditSeccionModal}
        handleClose={() => handleCloseModal('showEditSeccionModal')}
        seccion={modalState.currentSeccion}
        refreshSecciones={() => fetchSecciones().then(setSecciones)}
      />
      <CategoriaModal
        show={modalState.showCategoriaModal}
        handleClose={() => handleCloseModal('showCategoriaModal')}
        secciones={secciones}
        refreshCategorias={() => fetchCategorias().then(setCategorias)}
      />
      <EditCategoriaModal
        show={modalState.showEditModal}
        handleClose={() => handleCloseModal('showEditModal')}
        categoria={modalState.currentCategoria}
        secciones={secciones}
        refreshCategorias={() => fetchCategorias().then(setCategorias)}
      />
    </div>
  );
}

export default AdminCategorias;
